import {
  ClearingMarginIntServiceClient,
  ListClearingMarginIntRequest,
  ListClearingFeeDetailsRequest,
} from '../proto/feepb/feeclearingmarginint_grpc_web_pb';
import { notifyError } from '../components/Messages/Notification';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';


const service = new ClearingMarginIntServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);

export async function listClearingMarginInt(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListClearingMarginIntRequest();
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setRep(param.rep);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setChargeBy(param.chargeBy);
    req.setMonth(param.month);
    req.setYear(param.year);
    req.setFeeType(param.feeType);
    req.setStatus(param.status);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }


    service.listClearingMarginInt(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listClearingFeeDetails(param) {
  return new Promise((resolve, reject) => {
    const req = new ListClearingFeeDetailsRequest();
    req.setCorrespondent(param.correspondent);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setMonth(param.month);
    req.setYear(param.year);
    req.setFeeType(param.feeType);

    service.listClearingFeeDetails(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
